import { render, staticRenderFns } from "./EfficiencyReport.vue?vue&type=template&id=7661f924"
import script from "./EfficiencyReport.vue?vue&type=script&lang=js"
export * from "./EfficiencyReport.vue?vue&type=script&lang=js"
import style0 from "./EfficiencyReport.vue?vue&type=style&index=0&id=7661f924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports